import { Col, Button } from 'antd';
import styled from 'styled-components';

export const ProductContainer = styled.div<{ fullWidth?: boolean }>`
  padding: 5px 10px;
  width: ${(props) => (props.fullWidth ? '100%' : '320px')};
  min-height: 50px;

  .customSkeleton {
    width: 100% !important;
    height: 100%;
  }
`;

export const ProductDescription = styled.div`
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: center;

  .title {
    font-weight: bold;
    font-size: 17px;
  }
`;

export const PlanDetails = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PlanDetailsButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 15px;
  gap: 4px;
  height: 27px;
  border: 1px solid #4367e9;
  border-radius: 34px;
`;

export const SpanDetailButton = styled.span`
  height: 17px;
  font-weight: 500;
  font-size: 12px;
  line-height: 140%;
  color: #4367e9;
`;

export const ProductSummaryContainer = styled(Col)`
  width: 100%;
  margin-bottom: 25px;

  .product-title {
    font-weight: bold;
    font-size: 15px;
  }

  .total-price {
    font-size: 14px;
    font-weight: 500;
  }

  .product-price {
    font-size: 14px;
    font-weight: 500;
    display: flex;
    margin-right: 2.5%;
    flex-direction: column;

    .price-interval {
      font-size: 12px;
      font-style: italic;
    }
  }

  .titles-row {
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
    padding: 10px 0;
  }

  .items-row {
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
    padding: 10px 30px 10px 25px;
  }

  .total-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 25px;

    p {
      font-size: 12px;
      color: #494848;
      margin: 0 2rem 0 0;
    }
  }
`;
